import React from "react";
import firebase from "../../firebase";
import { connect } from "react-redux";
import { setCurrentChannel, setPrivateChannel } from "../../actions";
import {
  Menu,
  Icon,
  Modal,
  Form,
  Input,
  Button,
  Label
} from "semantic-ui-react";

class Channels extends React.Component {
  state = {
    activeChannel: "",
    user: this.props.currentUser,
    channel: null,
    channels: [],
    channelName: "",
    channelDetails: "",
    channelsRef: firebase.database().ref("channels"),
    messagesRef: firebase.database().ref("messages"),
    typingRef: firebase.database().ref("typing"),
    hashTagRef: firebase.database().ref("hasTag"),
    userRef: firebase.database().ref(`users/${this.props.currentUser.uid}`),
    notifications: [],
    modal: false,
    firstLoad: true,
    //親子チャンネル
    parentChannelsRef: firebase.database().ref("parent_channels"),
    parentChannels: [],
    hashTags: [],
    secretCode: "",
    presenceChannelRef: firebase.database().ref("presenceChannel"),
    previousChannel: "",
    isMounted: false,
    myData: ""
  };

  componentDidMount() {
    this.state.isMounted = true;

    //秘密の部屋コード
    this.state.userRef.on("value", snap => {
      if (this.state.isMounted) {
        snap.val() && this.setState({ secretCode: snap.val().secretCode });
      }
      //console.log("code:", this.state.secretCode);
    });

    this.addListeners();
    //親子チャンネル
    this.addListeners2();
    this.addListeners3();
  }

  //ハロリノから
  componentWillMount() {
    localStorage.getItem("myData") &&
      this.state.isMounted &&
      this.setState({
        myData: localStorage.getItem("myData")
      });
  }
  //ハロリノから
  componentWillUpdate() {
    // setter
    this.props.selectChannel &&
      localStorage.setItem("myData", this.props.selectChannel);
  }

  componentWillUnmount() {
    this.state.isMounted = false;
    this.removeListeners();
  }

  addListeners = () => {
    let loadedChannels = [];
    this.state.channelsRef.on("child_added", snap => {
      loadedChannels.push(snap.val());
      if (this.state.isMounted) {
        this.setState({ channels: loadedChannels }, () =>
          this.setFirstChannel()
        );
      }
      this.addNotificationListener(snap.key);
    });
  };

  //親子チャンネル
  addListeners2 = () => {
    let loadedChannels2 = [];
    this.state.parentChannelsRef.on("child_added", snap => {
      //console.log(snap.key);
      //loadedChannels2.push(snap.val());
      loadedChannels2[snap.key] = snap.val();
      this.state.isMounted &&
        this.setState({ parentChannels: loadedChannels2 }, () =>
          this.setFirstChannel()
        );
      this.addNotificationListener(snap.key);
    });
  };

  addListeners3 = () => {
    let loadedChannels3 = [];
    this.state.hashTagRef.on("child_added", snap => {
      //console.log(snap.key);
      loadedChannels3[snap.key] = snap.val();
      this.state.isMounted &&
        this.setState({ hashTags: loadedChannels3 }, () =>
          this.setFirstChannel()
        );
      this.addNotificationListener(snap.key);
    });
  };

  addNotificationListener = channelId => {
    this.state.messagesRef.child(channelId).on("value", snap => {
      if (this.state.channel) {
        this.handleNotifications(
          channelId,
          this.state.channel.id,
          this.state.notifications,
          snap
        );
      }
    });
  };

  handleNotifications = (channelId, currentChannelId, notifications, snap) => {
    let lastTotal = 0;
    let index = notifications.findIndex(
      notification => notification.id === channelId
    );
    if (index !== -1) {
      if (channelId !== currentChannelId) {
        lastTotal = notifications[index].total;
        if (snap.numChildren() - lastTotal > 0) {
          notifications[index].count = snap.numChildren() - lastTotal;
        }
      }
      notifications[index].lastKnownTotal = snap.numChildren();
    } else {
      notifications.push({
        id: channelId,
        total: snap.numChildren(),
        lastKnownTotal: snap.numChildren(),
        count: 0
      });
    }
    if (this.state.isMounted) {
      this.setState({ notifications });
    }
  };

  removeListeners = () => {
    this.state.channelsRef.off();
  };

  setFirstChannel = () => {
    const firstChannel = this.state.channels[0];
    //ハロリノから
    for (let channel of this.state.channels) {
      if (
        this.props.selectChannel === channel.id ||
        channel.id === this.state.myData
      ) {
        this.props.setCurrentChannel(channel);
        this.setActiveChannel(channel);
        this.addPresenceChannel(channel);
        if (this.state.isMounted) {
          this.setState({ channel: channel });
        }
      }
    }

    //参加中 初期設定
    firstChannel && this.addPresenceChannel(firstChannel);

    if (this.state.firstLoad && this.state.channels.length > 0) {
      this.props.setCurrentChannel(firstChannel);
      this.setActiveChannel(firstChannel);
      if (this.state.isMounted) {
        this.setState({ channel: firstChannel });
      }
    }
    if (this.state.isMounted) {
      this.setState({ firstLoad: false });
    }
  };

  addChannel = () => {
    const { channelsRef, channelName, channelDetails, user } = this.state;

    const key = channelsRef.push().key;

    const newChannel = {
      id: key,
      name: channelName,
      details: channelDetails,
      createdBy: {
        name: user.displayName,
        avatar: user.photoURL
      }
    };

    channelsRef
      .child(key)
      .update(newChannel)
      .then(() => {
        this.setState({ channelName: "", channelDetails: "" });
        this.closeModal();
        console.log("channel added");
      })
      .catch(err => {
        console.error(err);
      });
  };

  handleSubmit = event => {
    event.preventDefault();
    if (this.isFormValid(this.state)) {
      this.addChannel();
    }
  };

  handleChange = event => {
    if (this.state.isMounted) {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  commaSplit = str => {
    let resArray = str.split(",");
    let arr = [];
    for (var i = 0; i < resArray.length; i++) {
      arr.push(resArray[i]);
    }

    return arr;
  };

  hasSecretCode(channleCode, userCode) {
    let secret_code = this.commaSplit(userCode);
    for (let i = 0; i < secret_code.length; i++) {
      if (channleCode === secret_code[i]) return true;
    }
    return false;
  }

  changeChannel = channel => {
    this.setActiveChannel(channel);
    this.state.channel &&
      this.state.typingRef
        .child(this.state.channel.id)
        .child(this.state.user.uid)
        .remove();
    this.addPresenceChannel(channel);

    this.clearNotifications();
    if (
      channel.visible === "show" ||
      (this.state.secretCode &&
        this.hasSecretCode(channel.secretCode, this.state.secretCode))
      //channel.secretCode === this.state.secretCode
    ) {
      this.props.setCurrentChannel(channel);
      this.props.setPrivateChannel(false);
      if (this.state.isMounted) {
        this.setState({ channel });
      }
    }
  };

  // changeChannel2 = channel => {
  //   this.setActiveChannel(channel);
  //   // this.state.typingRef
  //   //   .child(this.state.channel.id)
  //   //   .child(this.state.user.uid)
  //   //   .remove();
  //   this.clearNotifications();
  //   if (channel.visible === "show") {
  //     this.props.setCurrentChannel(channel);
  //     this.props.setPrivateChannel(false);
  //     this.setState({ channel });
  //   }
  // };
  // changeChannel3 = channel => {
  //   this.setActiveChannel(channel);
  //   // this.state.typingRef
  //   //   .child(this.state.channel.id)
  //   //   .child(this.state.user.uid)
  //   //   .remove();
  //   this.clearNotifications();
  //   if (channel.visible === "show") {
  //     this.props.setCurrentChannel(channel);
  //     this.props.setPrivateChannel(false);
  //     this.setState({ channel });
  //   }
  // };

  clearNotifications = () => {
    let index = this.state.notifications.findIndex(
      notification => notification.id === this.state.channel.id
    );

    if (index !== -1) {
      let updatedNotifications = [...this.state.notifications];
      updatedNotifications[index].total = this.state.notifications[
        index
      ].lastKnownTotal;
      updatedNotifications[index].count = 0;
      if (this.state.isMounted) {
        this.setState({ notifications: updatedNotifications });
      }
    }
  };

  setActiveChannel = channel => {
    if (this.state.isMounted) {
      this.setState({ activeChannel: channel.id });
    }
  };

  getNotificationCount = channel => {
    let count = 0;
    this.state.notifications.forEach(notification => {
      if (notification.id === channel.id) {
        count = notification.count;
      }
    });
    if (count > 0) return count;
  };

  displayChannels = channels =>
    channels.length > 0 &&
    channels.visible !== "hide" &&
    channels.map(channel => (
      <Menu.Item
        key={channel.id}
        onClick={() => this.changeChannel(channel)}
        name={channel.name}
        style={{ opacity: 0.7 }}
        active={channel.id === this.state.activeChannel}
      >
        {this.getNotificationCount(channel) && (
          <Label color="red">{this.getNotificationCount(channel)}</Label>
        )}
        {/* # {channel.name} */}
        {this.isVisible(channel.visible, channel.name, channel.secretCode)}
      </Menu.Item>
    ));

  displaySingleChannels = channels =>
    channels.length > 0 &&
    channels.visible !== "hide" &&
    channels.map(
      channel =>
        this.isHelloRenoUser(channel) && (
          <Menu.Item
            key={channel.id}
            onClick={() => this.changeChannel(channel)}
            name={channel.name}
            style={{ opacity: 0.7 }}
            active={channel.id === this.state.activeChannel}
          >
            {this.getNotificationCount(channel) && (
              <Label color="red">{this.getNotificationCount(channel)}</Label>
            )}
            {/* # {channel.name} */}
            {this.isVisible(channel.visible, channel.name)}
          </Menu.Item>
        )
    );

  //親子チャンネル
  displayChannels2 = channels => {
    var list = [];
    //console.log(channels.key);
    for (const key in channels) {
      let children = [];
      if (channels.hasOwnProperty(key)) {
        const element = channels[key];
        //console.log(channels[key]);
        for (const key in element) {
          if (element.hasOwnProperty(key)) {
            const element2 = element[key];
            //console.log(element2.name);
            element2.visible !== "hide" &&
              children.push(
                <Menu.Item
                  key={element2.id}
                  onClick={() => this.changeChannel(element2)}
                  style={{ opacity: 0.7 }}
                  name={element2.name}
                  active={element2.id === this.state.activeChannel}
                >
                  {this.getNotificationCount(element2) && (
                    <Label color="red">
                      {this.getNotificationCount(element2)}
                    </Label>
                  )}
                  {/* # {element2.name} */}
                  {this.isVisible(element2.visible, element2.name)}
                </Menu.Item>
              );
          }
        }
        list.push(
          <Menu.Item key={key}>
            <b>{key}</b>
          </Menu.Item>
        );
      }
      list.push(
        <Menu.Menu className="menu" key={key + 1}>
          {children}
        </Menu.Menu>
      );
    }
    return list;
  };

  //ハッシュタグ
  displayHashTag = hashTags => {
    var list = [];
    //console.log(hashTags.key);

    for (const key in hashTags) {
      let children = [];
      if (hashTags.hasOwnProperty(key)) {
        const element = hashTags[key];
        //console.log(hashTags[key]);
        for (const key in element) {
          if (element.hasOwnProperty(key)) {
            const element2 = element[key];
            //console.log(element2);
            element2.visible !== "hide" &&
              children.push(
                /* <Menu.Item key={element2.id}> {element2.name}</Menu.Item> */
                <Menu.Item
                  key={element2.id}
                  onClick={() => this.changeChannel(element2)}
                  style={{ opacity: 0.7 }}
                  name={element2.name}
                  active={element2.id === this.state.activeChannel}
                >
                  {/* {element2.name} */}
                  {this.isVisible(element2.visible, element2.name)}
                </Menu.Item>
              );
          }
        }
        list.push(
          <Menu.Item key={key + 1}>
            <b># {key}</b>
          </Menu.Item>
        );
        list.push(<Menu.Menu key={key}>{children}</Menu.Menu>);
      }
    }
    return list;
  };

  isFormValid = ({ channelName, channelDetails }) =>
    channelName && channelDetails;

  openModal = () => this.setState({ modal: true });

  closeModal = () => this.setState({ modal: false });

  isVisible = (visible, name) => {
    if (visible === "show") {
      return "#" + name;
    } else if (visible === "secret") {
      return "#" + name + "(秘密の部屋)";
    }
  };

  //部屋に参加中の人
  addPresenceChannel = channel => {
    const { presenceChannelRef, user } = this.state;
    if (this.state.isMounted) {
      this.setState({ previousChannel: channel });
    }

    const newPresenceChannel = {
      avatar: user.photoURL
    };

    if (this.state.previousChannel.id) {
      // const oldRef = presenceChannelRef.child(this.state.previousChannel.id);
      // oldRef.remove();
      //console.log(user.uid);

      //var ref = firebase.database().ref("presenceChannel");
      presenceChannelRef
        .child(`${this.state.previousChannel.id}/${user.displayName}`)
        .remove();
    }

    if (user.displayName) {
      const newRef = presenceChannelRef
        .child(channel.id)
        .child(user.displayName);
      newRef.set(newPresenceChannel);
    }
  };

  isHelloRenoUser = channel => {
    //return this.props.selectChannel === channel.id;
    return (this.state.myData || this.props.selectChannel) === channel.id;
    //return this.hasSecretCode(channel.secretCode, this.state.secretCode);
  };

  isHelloRenoUser2 = channels => {
    channels.map(channel =>
      this.hasSecretCode(channel.id, this.state.secretCode) ? true : false
    );
  };

  render() {
    const { channels, modal, parentChannels, hashTags } = this.state;

    return (
      <React.Fragment>
        <Menu.Menu className="menu">
          <Menu.Item>
            <span>
              <Icon name="exchange" /> 部屋
            </span>
            ({channels.length})
            {/* <Icon name="add" onClick={this.openModal} /> */}
          </Menu.Item>
          {//this.isHelloRenoUser2(channels)
          this.state.myData || this.props.selectChannel
            ? this.displaySingleChannels(channels)
            : this.displayChannels(channels)}
        </Menu.Menu>
        {/* 親子チャンネル */}
        {/* {this.displayChannels2(parentChannels)} */}
        {/*ハッシュタグ */}
        {/* {this.displayHashTag(hashTags)} */}

        {/* Add Channel Modal */}
        <Modal basic open={modal} onClose={this.closeModal}>
          <Modal.Header>部屋を追加する</Modal.Header>
          <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
              <Form.Field>
                <Input
                  fluid
                  label="部屋名"
                  name="channelName"
                  onChange={this.handleChange}
                />
              </Form.Field>

              <Form.Field>
                <Input
                  fluid
                  label="部屋の説明"
                  name="channelDetails"
                  onChange={this.handleChange}
                />
              </Form.Field>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <Button color="green" inverted onClick={this.handleSubmit}>
              <Icon name="checkmark" /> 追加
            </Button>
            <Button color="red" inverted onClick={this.closeModal}>
              <Icon name="remove" /> キャンセル
            </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  selectChannel: state.channel.selectChannel
});

export default connect(
  mapStateToProps,
  { setCurrentChannel, setPrivateChannel }
)(Channels);



// WEBPACK FOOTER //
// ./src/components/SidePanel/Channels.js